function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDependentChild = function SvgDependentChild(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 188.94 167.57"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M54 62.35a31.18 31.18 0 1 0-31.17-31.18A31.29 31.29 0 0 0 54 62.35Zm0-7.61a23.57 23.57 0 1 1 23.5-23.57A23.57 23.57 0 0 1 54 54.74ZM134 62.35a31.18 31.18 0 1 0-31.14-31.18A31.29 31.29 0 0 0 134 62.35Zm0-7.61a23.57 23.57 0 1 1 23.5-23.57A23.57 23.57 0 0 1 134 54.74Z",
    style: {
      fill: "#ad112b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63 157.94v-43.86a46.22 46.22 0 0 1 80.34-31.3 54 54 0 0 1 4.92-6A53.93 53.93 0 0 0 0 114.08v51.49h78v-7.63Z",
    style: {
      fill: "#ad112b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 62.11a54 54 0 0 0-54 54v51.49h107.94v-51.52A54 54 0 0 0 135 62.11Zm-46.37 97.83c0-14.89 0-34.61.05-41.36v-2.5a46.26 46.26 0 1 1 92.52 0v43.86Z",
    style: {
      fill: "#ad112b"
    }
  }));
};
export default SvgDependentChild;